// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchResults_form__29Ruz","input":"SearchResults_input__1i_DZ","header":"SearchResults_header__gjms2","wrapper":"SearchResults_wrapper__3yGp9"};